import { useEffect, useRef } from "react";
import { useSidebar } from "../ui/sidebar";
import { useLocation } from "react-router-dom";

const getCurrentState = (saveKey: string) => {
  const savedState = localStorage.getItem("state-manager") || "{}";
  const state = JSON.parse(savedState);

  const currentState = state[saveKey] || {
    current_page: "",
    sidebar_open: true,
    scroll_position: 0,
  };
  return currentState;
};

export const updateState = (
  saveKey: string,
  partialState: Partial<{
    current_page: string;
    sidebar_open: boolean;
    scroll_position: number;
  }>
) => {
  const savedState = localStorage.getItem("state-manager") || "{}";
  const state = JSON.parse(savedState);

  const currentState = state[saveKey] || {
    current_page: "",
    sidebar_open: true,
    scroll_position: 0,
  };

  const updatedState = {
    ...currentState,
    ...partialState,
  };

  state[saveKey] = updatedState;

  localStorage.setItem("state-manager", JSON.stringify(state));
  return updatedState;
};

const StateManager = () => {
  const loaded = useRef(false);
  const listenState = useRef(false);
  const saveKey = useRef(
    localStorage.getItem("state-manager-key") || "default"
  );
  const { setOpen, open } = useSidebar();
  const location = useLocation();

  const loadCurrentState = () => {
    const state = getCurrentState(saveKey.current);
    setOpen(state.sidebar_open);

    if (
      state.current_page.split("/").length === 2 &&
      typeof state.scroll_position === "number"
    ) {
      setTimeout(() => {
        window.scrollTo(0, state.scroll_position);
      }, 50);
    }

    setTimeout(() => {
      listenState.current = true;
    }, 100);
  };

  useEffect(() => {
    if (loaded.current && listenState.current) {
      const stateUpdate = {
        sidebar_open: open,
        current_page: location.pathname,
      };

      updateState(saveKey.current, stateUpdate);
    }
  }, [open, location, location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        loaded.current &&
        listenState.current &&
        location.pathname.split("/").length === 2
      ) {
        updateState(saveKey.current, {
          scroll_position: window.scrollY,
        });
      }
    };

    let timeout: NodeJS.Timeout | null = null;
    const throttledScroll = () => {
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          handleScroll();
        }, 200);
      }
    };

    window.addEventListener("scroll", throttledScroll);

    return () => {
      window.removeEventListener("scroll", throttledScroll);
      if (timeout) clearTimeout(timeout);
    };
  }, [location.pathname]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const key = searchParams.get("key");
    if (key) {
      saveKey.current = key;
    }
    loadCurrentState();
    loaded.current = true;
  }, []);

  return null;
};

export default StateManager;
